import { getTplId, getAuthKey, getTplAndMeta } from '../http'
import filterPermissions from './FilterPermissions'
import { getMetaCache, setMetaCache } from './MetaCache'
import { multiInsert } from './MultiInsert'
import { XA01, AUTH_KEY, X_CHANGE_INFO, logInfo } from '../config'
import { getContext, getUrlParams } from '../util'
import { initGlobalConfig } from './GlobalConfig'

const TAG = '-controller: '

/**
 * 所有处理meta的相关逻辑必须在这里
 *  */
const getMetaData = async (param) => {
  let meta = {}
  try {
    if (isDesignPreview(param)) { // 设计器预览多为开发态，不需要做后续的操作 QDKJ-43340
      meta = await getTplAndMeta(param)
    } else {
      // 先缓存后接口
      meta = await getMetaCache(param) || await getTplAndMeta(param)
      // 字段权限控制、清洗meta
      meta = filterPermissions(meta);
      // 非设计器预览页面，更新metaCache
      setMetaCache(meta, param)
    }
    // 处理多语
    await multiInsert(meta, param.billNo, param)
    // 默认根节点没有多语 caption, 从Meta 元数据节点中够获取
    meta.caption = getCaption(meta)
  } catch (error) {
    logInfo(TAG, error)
  }
  return meta
}
const getCaption = (meta)=> {
  let caption = getBillTemplate(meta)?.caption
  return caption || meta.caption
}
export const getBillTemplate = (meta)=> {
  return meta?.children?.find(v => v.controlType === 'BillTemplate')
}
const isDesignPreview = (param = {}) => {
  if(param?.designPreview != undefined){
    return param.designPreview;
  }
  return getUrlParams(window.location.href)?.designPreview
}
async function pretreatment (billNo, query, params, pageParams) {
  await initGlobalConfig(query)
  await processApproval(query, params, billNo, pageParams)
}
/**
 * 处理打开待办消息时，传递临时TOKEN的场景
 * @param {*} query
 * @param {*} params
 * @param {*} billNo
 */
async function processApproval(query, params, billNo, pageParams) {
  if (query.from_mc_workflow && query.billId) {
    const context = getContext()
    if (params.tenantId && params.tenantId !== context.tenantid) {
      window.sessionStorage.setItem(X_CHANGE_INFO, params.tenantId)
    } else {
      window.sessionStorage.removeItem(X_CHANGE_INFO)
      window.sessionStorage.removeItem(XA01)
    }
    const res = await getAuthKey(billNo, params)
    if(!res) return
    if (res[XA01]) pageParams.current[XA01] = res[XA01]
    const ak = res?.data?.ADT || ''
    ak && window.sessionStorage.setItem(`${AUTH_KEY}_${query.billId}`, ak)
  }
}
export {
  getMetaData,
  getTplId,
  pretreatment,
  isDesignPreview
}
